import UserDAO from "./UserDAO";

export default class TokenDAO {
  static _key = "token";

  static get() {
    return UserDAO.getProperty(TokenDAO._key);
  }

  static set(token) {
    UserDAO.setProperty(TokenDAO._key, token);
  }

  static remove() {
    UserDAO.removeProperty(TokenDAO._key);
  }

}
